import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './img/wisdom/logo.png';
import _imports_1 from './img/wisdom/figure1.png';
const _hoisted_1 = {
  class: "wisdom-success-case"
};
const _hoisted_2 = {
  class: "success-case-banner"
};
const _hoisted_3 = {
  class: "case-info"
};
const _hoisted_4 = {
  class: "case-name"
};
const _hoisted_5 = {
  class: "tit"
};
const _hoisted_6 = {
  class: "case-title"
};
const _hoisted_7 = {
  class: "case-title"
};
const _hoisted_8 = {
  class: "desc"
};
const _hoisted_9 = {
  class: "doc-btn"
};
const _hoisted_10 = {
  class: "breadcrumb-box"
};
const _hoisted_11 = {
  class: "page-title"
};
const _hoisted_12 = {
  class: "thema-desc"
};
const _hoisted_13 = {
  class: "thema-desc"
};
const _hoisted_14 = {
  class: "thema-desc"
};
const _hoisted_15 = {
  class: "bottom-banner"
};
const _hoisted_16 = {
  class: "banner-con"
};
const _hoisted_17 = {
  class: "title"
};
const _hoisted_18 = {
  class: "consult-btn"
};
export function render(_ctx, _cache) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[0] || (_cache[0] = _createElementVNode("img", {
    src: _imports_0
  }, null, -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('successCase.text124')), 1)]), _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('successCase.text125')), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('successCase.text126')), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('successCase.text127')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('successCase.text128')), 1)])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_breadcrumb, {
    separator: "/"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, {
      to: {
        path: '/successCase'
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('successCase.text75')), 1)]),
      _: 1
    }), _createVNode(_component_el_breadcrumb_item, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('successCase.text129')), 1)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('successCase.text9')), 1), _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('successCase.text130')) + " " + _toDisplayString(_ctx.$t('successCase.text131')), 1), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "thema-figure"
  }, [_createElementVNode("img", {
    class: "thema-img",
    src: _imports_1
  })], -1)), _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('successCase.text132')), 1), _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('successCase.text133')), 1), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.$t('successCase.text17')), 1), _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('successCase.text18')), 1)])])]);
}